import React from "react";

import FullIcon from "../../assets/FastRealtyLogo.png";

const FullHeader = () => {
  return (
    <div className="fullHeader-root">
      <img src={FullIcon} alt="full-icon" className="full-icon" />
    </div>
  );
};

export default FullHeader;
